const missionSuccessfulIcon = `<svg width="100%" height="100%" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-miterlimit:10;">
    <g>
        <g>
            <g>
                <path d="M22.5,497C22.5,372.184 123.684,271 248.5,271C373.316,271 474.5,372.184 474.5,497L22.5,497Z" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:30px;"/>
            </g>
            <circle cx="286.505" cy="377.155" r="31.02" style="fill:none;stroke:white;stroke-width:30px;"/>
            <path d="M90.773,497L90.773,481.975C90.773,460.458 108.216,443.015 129.733,443.015C151.25,443.015 168.693,460.458 168.693,481.975L168.693,497" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:30px;"/>
            <path d="M398.498,435.754L368.498,435.754" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:30px;"/>
            <path d="M183.694,364.619L153.694,364.619" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:30px;"/>
        </g>
        <path d="M248.5,271L248.5,130.596" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:30px;"/>
        <path d="M341.153,130.596L341.153,188.394L489.5,188.394L489.5,72.798L411.995,72.798" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:30px;"/>
        <path d="M341.153,188.394L411.995,130.596L411.995,15L248.5,15L248.5,130.596L411.995,130.596" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:30px;"/>
    </g>
</svg>
`;

export default missionSuccessfulIcon;
